// Currency conversion rates (with ZAR as base)
// These are approximate exchange rates - you may want to use a real-time API in production
export const EXCHANGE_RATES = {
  ZAR: 1,     // South African Rand (base currency)
  USD: 0.053, // US Dollar
  EUR: 0.049, // Euro
  GBP: 0.042, // British Pound
  AUD: 0.081, // Australian Dollar
  CAD: 0.073  // Canadian Dollar
};

// Country code to currency code mapping
export const COUNTRY_CURRENCY = {
  // Africa
  ZA: 'ZAR', // South Africa
  
  // North America
  US: 'USD', // United States
  CA: 'CAD', // Canada
  
  // Europe
  GB: 'GBP', // United Kingdom
  IE: 'EUR', // Ireland
  DE: 'EUR', // Germany
  FR: 'EUR', // France
  IT: 'EUR', // Italy
  ES: 'EUR', // Spain
  PT: 'EUR', // Portugal
  NL: 'EUR', // Netherlands
  BE: 'EUR', // Belgium
  LU: 'EUR', // Luxembourg
  AT: 'EUR', // Austria
  
  // Australia & New Zealand
  AU: 'AUD', // Australia
  NZ: 'AUD'  // New Zealand
};

// Currency symbols
export const CURRENCY_SYMBOLS = {
  ZAR: 'R',
  USD: '$',
  EUR: '€',
  GBP: '£',
  AUD: 'A$',
  CAD: 'C$'
};

// Default formatting options for each currency
export const CURRENCY_FORMAT = {
  ZAR: { minimumFractionDigits: 0, maximumFractionDigits: 0 },
  USD: { minimumFractionDigits: 0, maximumFractionDigits: 0 },
  EUR: { minimumFractionDigits: 0, maximumFractionDigits: 0 },
  GBP: { minimumFractionDigits: 0, maximumFractionDigits: 0 },
  AUD: { minimumFractionDigits: 0, maximumFractionDigits: 0 },
  CAD: { minimumFractionDigits: 0, maximumFractionDigits: 0 }
};

// Function to convert price from ZAR to target currency and round up to nearest 10
export const convertAndRoundPrice = (priceInZAR, targetCurrency = 'ZAR') => {
  if (!EXCHANGE_RATES[targetCurrency]) {
    console.warn(`Exchange rate for ${targetCurrency} not found, using ZAR`);
    targetCurrency = 'ZAR';
  }
  
  // Convert from ZAR to target currency
  let convertedPrice = priceInZAR * EXCHANGE_RATES[targetCurrency];
  
  // Round up to nearest 10
  convertedPrice = Math.ceil(convertedPrice / 10) * 10;
  
  return {
    price: convertedPrice,
    currency: targetCurrency,
    symbol: CURRENCY_SYMBOLS[targetCurrency] || '',
    formatted: formatPrice(convertedPrice, targetCurrency)
  };
};

// Format price with currency symbol
export const formatPrice = (price, currency = 'ZAR') => {
  const symbol = CURRENCY_SYMBOLS[currency] || '';
  const options = CURRENCY_FORMAT[currency] || { minimumFractionDigits: 0, maximumFractionDigits: 0 };
  
  return `${symbol}${price.toLocaleString(undefined, options)}`;
};

// Detect user's country and return appropriate currency
export const detectUserCurrency = async () => {
  try {
    // First try to use browser's geolocation API if available
    if (navigator && navigator.geolocation) {
      try {
        const position = await new Promise((resolve, reject) => {
          navigator.geolocation.getCurrentPosition(
            position => resolve(position),
            error => reject(error),
            { timeout: 5000, maximumAge: 60000 }
          );
        });
        
        // Use reverse geocoding to get country from coordinates
        const { latitude, longitude } = position.coords;
        const geoResponse = await fetch(`https://api.bigdatacloud.net/data/reverse-geocode-client?latitude=${latitude}&longitude=${longitude}&localityLanguage=en`);
        const geoData = await geoResponse.json();
        
        if (geoData && geoData.countryCode) {
          console.log('Detected country from geolocation:', geoData.countryCode);
          const currency = COUNTRY_CURRENCY[geoData.countryCode] || 'ZAR';
          console.log('Using currency from geolocation:', currency);
          return currency;
        }
      } catch (geoError) {
        console.log('Geolocation error or denied, falling back to IP detection:', geoError);
        // Fall through to IP-based detection
      }
    }
    
    // Fall back to IP geolocation service
    const response = await fetch('https://ipapi.co/json/');
    const data = await response.json();
    
    const countryCode = data.country_code;
    console.log('Detected country from IP:', countryCode);
    
    // Get currency for country or default to ZAR
    const currency = COUNTRY_CURRENCY[countryCode] || 'ZAR';
    console.log('Using currency from IP:', currency);
    
    return currency;
  } catch (error) {
    console.error('Error detecting location:', error);
    return 'ZAR'; // Default to ZAR if geolocation fails
  }
}; 